export default __webpack_public_path__ + "static/media/Lender.0e52a93c.png";